import i18next from 'i18next';
import React from 'react';

// Takes a raw string and replaces any {placeholder} tokens with the provided placeholder.
// Returns the input if no placeholders have been provided, or if there are no tokens in the string. 
// Otherwise, returns an array of items in order where the {placeholder} tokens have been 
// replaced by the provided placeholders.
//   > replace("hello, {place}", { place: "world"})  
//   < ["hello", "world"]
// Note: this format is necessary to allow for React elements to be used as placeholders.
// joining this array results in rendering the string value of the element instead of the element itself.
const replace = (raw, placeholders) => {
  if (!raw) {
    return '';
  }

  const sansPlaceholders = raw.split(/\{[^}]+\}/);
  if (sansPlaceholders.length <= 1 || !placeholders) {
    // no tokens, or no placeholders. return the original
    return raw;
  }

  // extract the placeholder names.
  const names = raw.match(/\{[^}]+\}/g);
  const stripped = names.map((placeholder) => {
    return placeholder.slice(1, -1);
  });

  const result = [];
  for (var i = 0; i < sansPlaceholders.length; i++) {
    result.push(sansPlaceholders[i]);
    if (i < sansPlaceholders.length - 1) {
      result.push(placeholders[stripped[i]]);
    }
  }
  return result;
};

// whether or not the set of placeholders is simple (that is, no objects)
const simple = (placeholders) => {
  if (placeholders) {
    for (const value of Object.values(placeholders)) {
      if (typeof value === 'object') {
        // at least one of these placeholders is complex
        return false;
      }
    }
  }

  // it's simple!
  return true;
};

// translates the provided key into the current language, replacing any
// { placeholder } tokens.
// if there are no placeholders, returns a string.
// if there only are simple (string) placeholders, returns a string.
// if there are any complex (React Element) placeholders, returns a React element.
export const translate = (key, placeholders) => {
  if (simple(placeholders)) {
    return i18next.t(key, placeholders);
  } else {
    // this is has complex (e.g. React element) placeholders, 
    // so replace those and construct an element for our translation
    // so we can display them properly and return it
    return React.createElement(
      (props) => React.createElement(
        React.Fragment, null, ...replace(
          i18next.t(key, { skipInterpolation: true }), 
          props
        )
      ), placeholders);
  }
};
